const detail = {
  invoiceInfo: [
    {
      name: 'storage',
      text: 'refund.refund_refund-warehousing-warehouse',
      component: 'SelectStorageName',
      required: true
    },
    {
      name: 'refundDate',
      text: 'refund.refund_refund-date',
      component: 'NormalDatePicker',
      required: true
    }
  ]
}

export default { detail }
